var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuMyPet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.08 15.72C18.49 12.19 15.1 9.32001 11.52 9.32001C7.62997 9.32001 4.20997 12.47 3.87997 16.35C3.74997 17.85 4.22997 19.27 5.21997 20.34C6.19997 21.41 7.57997 22 9.07997 22H13.76C15.45 22 16.93 21.34 17.94 20.15C18.95 18.96 19.35 17.38 19.08 15.72Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.28 7.86C11.8982 7.86 13.21 6.54819 13.21 4.93C13.21 3.31181 11.8982 2 10.28 2C8.66178 2 7.34998 3.31181 7.34998 4.93C7.34998 6.54819 8.66178 7.86 10.28 7.86Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.94 9.02999C18.2876 9.02999 19.38 7.93757 19.38 6.58999C19.38 5.24242 18.2876 4.14999 16.94 4.14999C15.5924 4.14999 14.5 5.24242 14.5 6.58999C14.5 7.93757 15.5924 9.02999 16.94 9.02999Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.55 12.93C21.6269 12.93 22.5 12.057 22.5 10.98C22.5 9.90304 21.6269 9.03 20.55 9.03C19.473 9.03 18.6 9.90304 18.6 10.98C18.6 12.057 19.473 12.93 20.55 12.93Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.94 10.98C5.28757 10.98 6.38 9.88758 6.38 8.54001C6.38 7.19243 5.28757 6.10001 3.94 6.10001C2.59243 6.10001 1.5 7.19243 1.5 8.54001C1.5 9.88758 2.59243 10.98 3.94 10.98Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuMyPet);
export default __webpack_public_path__ + "static/media/menu-my-pet.d7b7b19ad21024c3afae8e64a0231ea9.svg";
export { ForwardRef as ReactComponent };